// NPM Imports
import React from "react";
import PropTypes from "prop-types";
import { GoogleLogin } from "react-google-login";

// Methods Imports
import { getGoogleAuthClientCode } from "../../AuthService/authMethods";

// Decalaration
const DARK_THEME = "dark";

const GoogleAuth = props => (
  <GoogleLogin
    clientId={getGoogleAuthClientCode()}
    buttonText={props.btnTitle}
    onSuccess={props.onSuccess}
    onFailure={props.onFailure}
    theme={DARK_THEME}
    cookiePolicy="single_host_origin"
  />
);

GoogleAuth.propTypes = {
  btnTitle: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onFailure: PropTypes.func.isRequired,
};

export default GoogleAuth;
